import { __awaiter, __generator } from "tslib";
import { KeySellingPointsMode } from './enums/key-selling-points-mode';
import { fetchGetProductCatalogue } from './http/fetch-get-product-catalogue';
import { SubEntityType } from './models/sub-entity-type';
import { getFetchSubEntitiesUrl } from './utilities/get-fetch-sub-entities-url';
export var fetchGroupKeySellingPoints = function (groupId, mode, includeType) {
    if (mode === void 0) { mode = KeySellingPointsMode.Regular; }
    return __awaiter(void 0, void 0, void 0, function () {
        var url;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = getFetchSubEntitiesUrl(groupId, SubEntityType.KeySellingPoints, "g" /* Group */, includeType);
                    url += "&kspMode=" + mode;
                    return [4 /*yield*/, fetchGetProductCatalogue(url)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
};
